module.exports = "<bulkcredits-page></bulkcredits-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/bulkcredits.html
// module id = 1571
// module chunks = 0